// strings that match profile jso fields in profile APIs (exceptions when noted)
// useful for updating profile, form names, and other things that identify profile fields

// examples...
// Reading a particular field from the jobseeker's profile jso format that the API sends
// Mapping each field in a form, such as initial values, input name, validation
// Doing any transformations to the fields after form submit for a profile patch

export const NAME = 'name';
export const PHONE_NUMBER = 'phone_number';

// resume parsing likes using this field instead of phone_number
export const MOBILE = 'mobile';

export const RESUME = 'resume';
export const RESUME_NAME = 'resume_name'; // not a profile jso field, used in forms with resume and displays its name

export const EXPERIENCE = 'job_history';
export const EXPERIENCE_POSITION = 'position';
export const EXPERIENCE_EMPLOYER = 'employer';

export const EDUCATION = 'school_history';
export const EDUCATION_SCHOOL = 'school';
export const EDUCATION_DEGREE = 'name';
export const EDUCATION_MAJOR = 'major';

// common fields to multiple sections
export const START_DATE = 'start_date';
export const END_DATE = 'end_date';
export const CURRENT = 'current';
export const DESCRIPTION = 'description';

export const RDB_OPT_IN = 'rdb_opt_in';
